export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.6-1643.12',
  commitId: '2adf5ab831905acd251c4a8b9567af205473cb6d',
  commitTime: '2026-02-06T16:43:12.000Z',
});
